export const XingIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.774 20"><path fill="#fff" d="M7.53 7.945q-.125.221-3.245 5.512a.973.973 0 0 1-.819.558H.452a.426.426 0 0 1-.393-.643l3.194-5.414q.014 0 0-.013L1.221 4.57c-.2-.348.014-.629.393-.629h3.013a.961.961 0 0 1 .833.545ZM17.709.629l-6.666 11.292v.013l4.24 7.436a.4.4 0 0 1-.393.629h-3.018a.923.923 0 0 1-.833-.545l-4.278-7.519 6.7-11.39a.934.934 0 0 1 .81-.545h3.041a.407.407 0 0 1 .393.629Z" data-name="Icon awesome-xing"/></svg>
  );
};
